import { BUSINESS, SITE_URL } from '../config/business';

export interface FaqEntry {
  question: string;
  answer: string;
}

export type JsonLd = Record<string, unknown>;

/** Référence au LocalBusiness déclaré globalement dans index.html. */
export const BUSINESS_REF = { '@id': `${SITE_URL}/#business` } as const;

export const buildFaqSchema = (faqs: FaqEntry[]): JsonLd => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(({ question, answer }) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: { '@type': 'Answer', text: answer },
  })),
});

interface ServiceSchemaInput {
  name: string;
  serviceType: string;
  path: string;
  description: string;
  cities: string[];
  offers?: { name: string; priceFrom: number }[];
}

export const buildServiceSchema = ({
  name,
  serviceType,
  path,
  description,
  cities,
  offers = [],
}: ServiceSchemaInput): JsonLd => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name,
  serviceType,
  description,
  url: `${SITE_URL}${path}`,
  provider: BUSINESS_REF,
  areaServed: cities.map((city) => ({ '@type': 'City', name: city })),
  ...(offers.length > 0 && {
    offers: offers.map((offer) => ({
      '@type': 'Offer',
      name: offer.name,
      priceCurrency: 'EUR',
      priceSpecification: {
        '@type': 'PriceSpecification',
        minPrice: offer.priceFrom,
        priceCurrency: 'EUR',
      },
      seller: { '@type': 'LocalBusiness', name: BUSINESS.name, ...BUSINESS_REF },
    })),
  }),
});
